import { Link } from "react-router-dom";
import { FAQ } from "@/seo/faq";
import { GHL_SOCIAL_FORM_URL } from "@/seo/pages";
import { useUpcomingEvents } from "@/lib/useUpcomingEvents";
import { prettyDate } from "@/pages/events/eventUtils";

export const TeacherSection = () => (
  <section className="bg-ivory border-t border-temple/10" data-testid="home-teacher">
    <div className="max-w-[1320px] mx-auto px-6 md:px-12 py-24 md:py-36 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-4">
        <p className="eyebrow">Your teacher</p>
        <h2 className="mt-6 font-serif font-light text-temple text-4xl md:text-6xl leading-[1.05]" data-testid="teacher-name">
          Johnny<br />
          <span className="italic text-stone">Cantiveros.</span>
        </h2>
        <p className="mt-6 eyebrow eyebrow--stone">Shiva Murti Lineage Teacher</p>
      </div>
      <div className="md:col-span-7 md:col-start-6 font-sans font-light text-temple text-base md:text-lg leading-[1.9] space-y-6 max-w-prose" data-testid="teacher-bio">
        <p>
          Johnny is one of only four teachers authorized to pass on the Shiva
          Murti lineage worldwide. He has trained with his teacher Jero Jason
          Stepina and High Priest Ratu Nabe in Bali, Indonesia over the past
          five years.
        </p>
        <p>
          He has earned the Gana Usadha 2 designation, with the ability to offer
          Sacred Moon Blessings and purifications, cord cutting, property
          purifications and sacred activations, on top of effective and
          efficient healing sessions.
        </p>
        <p>
          Based in Vancouver, Johnny Cantiveros offers healing sessions in
          person and by video, and trains new practitioners through initiation.
        </p>
      </div>
    </div>
  </section>
);

const Row = ({ label, children }) => (
  <div className="py-5 border-t border-ivory/15 grid grid-cols-[7rem_1fr] gap-6">
    <dt className="eyebrow">{label}</dt>
    <dd className="font-sans font-light text-ivory text-base md:text-lg leading-[1.7]">{children}</dd>
  </div>
);

export const NextSocial = () => {
  const { events } = useUpcomingEvents();
  const ev = events[0];
  if (!ev) return null;
  return (
    <section className="bg-temple text-ivory grain" data-testid="home-next-social">
      <div className="max-w-[1320px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="eyebrow">Next gathering · In person</p>
          <h2 className="mt-6 font-serif font-light text-ivory text-4xl md:text-6xl leading-[1.05]" data-testid="next-social-title">
            {ev.title}<br />
            <span className="italic text-gold">{ev.city_word}.</span>
          </h2>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <dl className="border-b border-ivory/15" data-testid="next-social-details">
            <Row label="When">
              {prettyDate(ev.date)} · {ev.start_time}
              {ev.end_time ? ` – ${ev.end_time}` : ""}
            </Row>
            <Row label="Where">{ev.venue}, {ev.address}</Row>
            <Row label="Admission">Complimentary · Limited to {ev.capacity} guests</Row>
          </dl>
          <div className="mt-10 flex flex-wrap items-center gap-8">
            <a
              href={GHL_SOCIAL_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-7 py-4 bg-ivory text-temple border border-gold font-sans text-[0.72rem] tracking-[0.28em] uppercase hover:bg-temple hover:text-ivory transition-colors duration-500"
              data-testid="next-social-rsvp"
            >
              Reserve your place
              <span aria-hidden>→</span>
            </a>
            <Link
              to={`/socials/${ev.slug}`}
              className="font-sans text-[0.72rem] tracking-[0.28em] uppercase text-gold underline underline-offset-4 hover:text-ivory transition-colors"
              data-testid="next-social-details-link"
            >
              The evening
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export const FaqSection = () => (
  <section className="bg-ivory border-t border-temple/10" data-testid="home-faq">
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-24 md:py-36">
      <p className="eyebrow">Questions</p>
      <h2 className="mt-6 font-serif font-light text-temple text-4xl md:text-6xl leading-[1.05]">
        Asked, and<br />
        <span className="italic text-stone">answered.</span>
      </h2>
      <dl className="mt-14 border-t border-gold/60" data-testid="faq-list">
        {FAQ.map((f, i) => (
          <div key={f.q} className="py-8 border-b border-temple/15" data-testid={`faq-item-${i}`}>
            <dt className="font-serif font-light text-temple text-2xl md:text-3xl leading-[1.2]">{f.q}</dt>
            <dd className="mt-4 font-sans font-light text-temple/85 text-base md:text-lg leading-[1.8]">{f.a}</dd>
          </div>
        ))}
      </dl>
    </div>
  </section>
);
